import { createReducer } from '../../utils/createReducer';
import { FullscreenPreviewState } from '../types';

import { OPEN_FULLSCREEN_PREVIEW, CLOSE_FULLSCREEN_PREVIEW } from '../actions/types';

const initialState = {
  src: '',
  alt: '',
  width: 0,
  height: 0,
  visible: false
};

const fullscreenPreviewReducer = {
  [OPEN_FULLSCREEN_PREVIEW]: (state, { payload }) => {
    const { src, width, height } = payload;
    return { ...state, src, width, height, visible: true };
  },

  [CLOSE_FULLSCREEN_PREVIEW]: () => ({ ...initialState })
};

export default function fullscreenPreview(state = initialState, action) {
  return createReducer(fullscreenPreviewReducer, state, action);
}
